<nav
  class="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
  [class.nav-scrolled]="scrolled()"
>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between h-18 py-4">
      <div class="flex items-center gap-3 cursor-pointer" (click)="goHome()">
        <img class="logo-icon" src="brand/trieon-tech-logo.png" alt="Trieon Technologies" width="40" height="40" />
        <span class="brand-wordmark">
          <span class="brand-wordmark__name">Trieon</span>
          <span class="brand-wordmark__suffix">Technologies</span>
        </span>
      </div>

      <div class="hidden md:flex items-center gap-8">
        @for (link of navLinks; track link.label) {
          <a
            class="nav-link text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors duration-200 cursor-pointer"
            (click)="goToSection(link.href)"
          >{{ link.label }}</a>
        }
      </div>

      <div class="flex items-center gap-4">
        <button
          class="hidden md:inline-flex items-center gap-2 px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300 cta-btn"
          (click)="goToSection('contact')"
        >
          Get in Touch
          <i class="pi pi-arrow-right text-xs"></i>
        </button>

        <button
          class="md:hidden p-2 text-slate-500 hover:text-slate-900"
          (click)="toggleMobileMenu()"
          aria-label="Toggle menu"
        >
          <i class="pi text-xl" [class.pi-bars]="!mobileMenuOpen()" [class.pi-times]="mobileMenuOpen()"></i>
        </button>
      </div>
    </div>
  </div>

  @if (mobileMenuOpen()) {
    <div class="md:hidden mobile-menu">
      <div class="px-4 py-4 flex flex-col gap-4">
        @for (link of navLinks; track link.label) {
          <a
            class="text-slate-600 hover:text-slate-900 font-medium py-2 border-b border-slate-100 cursor-pointer"
            (click)="goToSection(link.href)"
          >{{ link.label }}</a>
        }
        <button
          class="mt-2 px-5 py-2 rounded-full text-sm font-semibold cta-btn"
          (click)="goToSection('contact')"
        >
          Get in Touch
        </button>
      </div>
    </div>
  }
</nav>
